export interface FeatureTag {
    [id: string]: {
        name: string;
        description: string;
        active: boolean;
    };
}

const featureFlag: FeatureTag = {
    pending: {
        name: 'Pending',
        description: 'Use redux pending queries',
        active: true,
    },
    resetRecent: {
        name: 'resetRecent',
        description: 'Use to remove recent address from localStorage',
        active: false,
    },
    selfService: {
        name: 'selfService',
        description: 'Activate if selfService is accessible',
        active: false, // process.env.REACT_APP_ACCESS_SELF_SERVICE === 'true',
    },
    canDownloadBill: {
        name: 'canDownloadBill',
        description: 'Activate to be able to download Bills',
        active: process.env.REACT_APP_DOWNLOAD_BILL === 'true',
    },
    queryDebugLogs: {
        name: 'queryDebugLogs',
        description: 'Active to show query Debug Logs',
        active: false && process.env.NODE_ENV !== 'production',
    },
    queryDuplicateRemover: {
        name: 'queryDuplicateRemover',
        description: 'Active to remove duplicate queries automaticaly (cf constant file for settings)',
        active: false,
    },
    didomi: {
        name: 'didomi',
        description: 'Activate RGPD - Didomi',
        active: true,
    },
    exportRGPD: {
        name: 'exportRGPD',
        description: 'Export RGPD - client infos',
        active: false,
    },
    paymentInFlow: {
        name: 'paymentInFlow',
        description: 'Activate payment in booking flow',
        active: false,
    },
    onBoarding: {
        name: 'onBoarding',
        description: 'Activate on Boarding modal',
        active: true,
    },
    askCancelReason: {
        name: 'askCancelReason',
        description: 'Activate to ask for cancellation reason',
        active: false,
    },
    eventCheck: {
        name: 'eventCheck',
        description: 'Activate to check for events at start',
        active: false,
    },
    partialCoverage: {
        name: 'partialCoverage',
        description: 'Activate partial coverage (prise en charge partielle) on the company payment means - LT-1840',
        // The voucher CRUD is live on staging; the LT-1841 half still needs `voucher_id`
        // handled by PUT /payment-methods/settings before a partial group can be saved.
        active: true,
    },
};

export default featureFlag;
